import { Component, OnInit } from '@angular/core';
import { IdentityService } from '@services/identity.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

    users: any[] = [];
    constructor(private appService: IdentityService) {
      
    }
  
    ngOnInit() {
      this.getUsers();
    }
  
  
    getUsers() {
      this.appService.getUsers().subscribe(res => {
        this.users = res;
        console.table(res);
  
      })
    }
}
